export const DATE_FORMATS = {
  // Number of date: 01, 15, 31
  DAY_NUMBER: "DD",
  // Short day name of week: mon, wed, sun
  DAY_NAME_OF_WEEK_SHORT: "ddd",
  // Number of month: 01, 07, 12
  MONTH_NUMBER: "MM",
  // Short name of month: Apr, Jul, Dec
  MONTH_NAME_SHORT: "MMM",
  // Full year value: 2024
  YEAR_FULL: "YYYY",
};
